import React from 'react'
import '../../../css/Employer/Register.css'
import ArrowRightCircle from '../../../assets/images/fluent-icons/ArrowRightCircle-24-Filled.svg'

function Register() {
    return (
        <div className="purple-container py-5 container-fluid">
            <h1 className="py-3">Get in contact with us</h1>
            <div className="container">
                <div className="justify-content-md-center">
                    <a className="" href="mailto:msaccelerate@hotmail.com?subject=MSA Employer Registration">
                        <img className="fluent-icon" src={ArrowRightCircle} alt="Right arrow button"/>
                    </a>
                </div>
            </div>
        </div>
    )
}
export default Register;